module.exports = __webpack_public_path__ + "img/menu_chart_on.63dc2fe0.svg";